import React from "react";
import CustomText from "./typography/CustomText";

export default function StatusBadge({
  variant = "active",
  size = "medium",
  color = "inherit",
}) {
  variant = String(variant).toLocaleLowerCase();
  return (
    <div>
      <CustomText
        variant={size === "medium" ? "h6" : size}
        // bold={600}
        color={color}
        className="capitalize"
      >
        <CustomText
          variant="inherit"
          // bold={600}
          color={
            variant === " "
              ? "success"
              : variant === "disabled"
              ? "error"
              : "warning"
          }
          component="span"
          className="pr-2 text-13"
        >
          ◼
        </CustomText>
        <span className="text-13">{variant}</span>
      </CustomText>
    </div>
  );
}

export function CustomStatusBadge({
  text = "",
  variant = "success",
  size = "medium",
  color = "inherit",
}) {
  variant = String(variant).toLocaleLowerCase();
  return (
    <div>
      <CustomText
        variant={size === "medium" ? "h6" : size}
        // bold={600}
        color={color}
        className="capitalize"
      >
        <CustomText
          variant="inherit"
          // bold={600}
          color={variant}
          component="span"
          className="pr-2"
        >
          ◼
        </CustomText>
        <span className="text-13">{text}</span>
      </CustomText>
    </div>
  );
}
